import React, { useState, useRef, useCallback } from 'react';
import { Workbook, WorkbookInstance } from "@fortune-sheet/react";
import "@fortune-sheet/react/dist/index.css";
import { Sheet } from '@fortune-sheet/core';

interface ExcelSheetProps {
    initialData?: Sheet[];
    onChange?: (data: Sheet[]) => void;
}

const ExcelSheet: React.FC<ExcelSheetProps> = ({ initialData = [], onChange }) => {
    const workbookRef = useRef<WorkbookInstance | null>(null);
    const [key, setKey] = useState(0);
    const [baseData, setBaseData] = useState<Sheet[]>(
        initialData.length > 0 ? initialData : [{ name: 'Sheet1', celldata: [{ r: 0, c: 0, v: null }] }]
    );
    const [workbookData, setWorkbookData] = useState<Sheet[]>([]);

    

    // const handleButtonClick = () => {
    //     if (workbookRef.current) {
    //         workbookRef.current.setCellValue(1, 1, "This is Value");
    //         const firstCellValue = workbookRef.current.getCellValue(0, 0);
    //         console.log(`Value of the first cell: ${firstCellValue}`);
    //     } else {
    //         alert('Workbook reference is not available');
    //     }
    // };

    //This approach will not work because the data is different. You need to convert the cellData to data. see:
    //https://stackoverflow.com/questions/77874938/updating-the-sheet-data-on-refresh-react-fortune-sheets-component

    //Or use OnOp function and save the changes in the localDb or Mongo so that it creates. 
    //Refer to https://github.com/ruilisi/fortune-sheet/tree/master/backend-demo
    const handleRerender = () => {
        setBaseData(workbookData);
        setKey(prevKey => prevKey + 1);
        console.log(baseData)
    };
    const handleChange = useCallback((data: Sheet[]) => {
        setWorkbookData(data);
        if (onChange) {
            onChange(data);
        }
    }, [onChange]);


    return (
        <>
            {/* <button onClick={handleButtonClick}>Alert First Cell Value</button> */}
            {/* <button onClick={() => console.log(JSON.stringify(workbookData))}>Print Workbook Data</button>
            <button onClick={() => console.log(JSON.stringify(baseData))}>Base Data</button>
            <button onClick={handleRerender}>Re-render Component</button> */}
            <div style={{ width: '100%', height: '100%' }}>
                <Workbook ref={workbookRef} key={key} currency='inr' data={baseData} onChange={handleChange} lang='en'/>
            </div>
        </>
    );
};

export default ExcelSheet;
